import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        "&&&&:before": {
            borderBottom: "0px solid rgba(0, 0, 0, 0)"
        },
        "&&&&:hover:before": {
          borderBottom: "0px solid rgba(0, 0, 0, 0)"
        }
      }
    }
  }
});
class RiskDriverConsequence extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            driver: this.props.driver,
            consequence: this.props.consequence
        }
    }

    handleDriversTextChange = (name, index, event) => {
        //console.log(this.Risk_info_temp)
        let value = event.target.value
        this.setState((state)=>{ 
            this.state[name][index] = value 
            
            this.props.submitChange(name, this.state[name])
        })
        this.forceUpdate()
    };

    handleAddNew = (event) => {
        // get the type (as data-value in the dom element), here need to use its parent, because the event target return only the button not its wrapper
        //console.log(event.target.parentNode.dataset)
        //console.log(event.target.parentNode)
        let type = event.target.parentNode.dataset.value
        // if click on the border of the button, it returns the parents........
        if (type == null) {
            type = event.target.dataset.value
        }
        let updateList = this.state[type]
        //console.log(this.state)
        //console.log(type)
        //console.log(updateList)
        updateList.push("")
        //console.log(updateList)
        this.setState({[type]: updateList}, ()=>{
            this.props.submitChange(type, updateList)
        })
    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props.riskname !== prevProps.riskname) {
            console.log("peops changede")
            this.setState({
                driver: this.props.driver,
                consequence: this.props.consequence
            })
        }
    }

    handleDrop = (event) => {
        let type = event.target.parentNode.dataset.value
        let index = event.target.parentNode.dataset.index
        // if click on the border of the button, it returns the parents........
        if (type == null) {
            type = event.target.dataset.value
            index = event.target.dataset.index
        }
        console.log(type, index)
        let updateList = this.state[type]
        updateList.splice(index, 1)
        this.setState({[type]: updateList}, ()=>{
            this.props.submitChange(type, updateList)
        })
    }

    render() {
        const { classes } = this.props;
        const filllist = (data, name, state_name)=>{
            return(
                <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                    <typography style={{ display: 'inline-block', minWidth: '160px', width:"20%", verticalAlign:"top", paddingTop:"10px"}}> {name} </typography>
                    <div style={{display:'inline-block', textAlign:'left', minWidth:'120px', width:"70%"}}>
                        <List>
                            {data.map((dataitem, index)=>{
                                return (
                                    <div>
                                        <ListItem style = {{padding:0}}>
                                            <Button
                                                data-value={state_name}
                                                data-index={index}
                                                variant='outlined'
                                                color='secondary'
                                                className={classes.button}
                                                onClick= {this.handleDrop}
                                            >
                                                Drop
                                            </Button>
                                            <div style={{paddingRight:'15px'}}>•</div>
                                            <TextField
                                                id = 'driver'
                                                fullWidth = "true"
                                                multiline = "true"
                                                onChange = {(event) => this.handleDriversTextChange(state_name, index, event)}
                                                value = {this.state[state_name][index]}
                                                placeholder = {this.state[state_name][index]}
                                            />
                                        </ListItem>
                                        <div style={{paddingBottom:'5px'}}/>
                                    </div>
                                )
                            })}
                        </List>
                        <Divider className={classes.divider_within_form}/>
                        <div style={{ display: 'block', textAlign:'center'}}>
                            <Button data-value={state_name} variant="outlined" color="primary" className={classes.button} onClick= {this.handleAddNew}>
                                Add New
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        const driverslistEdit = filllist(this.state.driver, 'Risk Drivers      ', 'driver')
        const consequenceslistEdit = filllist(this.state.consequence, 'Risk Consequences ', 'consequence')

        return(
            <MuiThemeProvider theme={theme}>
                <div>
                    <Typography variant = "h6"  align="left" className={classes.FormHeader}> C. Drivers & Consequences </Typography>
                    <Divider className={classes.FormDivider}/>
                    {driverslistEdit}
                    {consequenceslistEdit}
                </div>
            </MuiThemeProvider>    
        )
    }
}

export default withStyles(styles)(RiskDriverConsequence);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/C.js